<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/m7vpR2/images/cover.jpg?1724526711467" alt="This image is the cover for the book Serpent and the Soul"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Serpent and the Soul
      </h1>
      <p class="bookDescription body article font2">
        <b>Healing cannot happen unless you confront the demonic strongholds attacking you.</b><br/>  <br/> After reading this book, you will discover the strategies of Python, and Leviathan; identify their primary targets; and learn how to defeat them. You will gain confidence and understanding to sever the strongholds gripping your life. Instead of being constricted by serpent spirits, you will walk free in the power of Christ.<br/>  <br/> Jesus gave us the power to trample serpents and have authority of the power of the enemy in Luke 10:19. Isaiah 27:1-3 identifies Leviathan as a twisting, fleeing serpent. This spirit operates in relationships at all levels and twists people’s words, shooting darts between people and causing division. Not only does it ruin relationships, but healing minister Katie Souza believes it ruins our health and our daily lives.<br/>  <br/><i>The Serpent and the Soul</i> shows you the many ways we allow the Leviathan (serpent) spirit into our lives and the impact it has on us. Python is another serpent spirit and it constricts our finances and causes lack and misalignment in our lives and our physical bodies. So many misunderstand or overlook the connection between idolatry, witchcraft, and these serpent spirits and the impact they have our bodies. Souza has seen this time and time again throughout her years of ministry. <br/>  <br/> But there is good news. You can break the serpents’ deadly grip through genuine repentance of pride, unforgiveness, and other doors these spirits use to gain access to your life. Your relationships can thrive again, and you can prosper and live in health and peace. This book will impart biblical understanding of Python, Leviathan, and other serpent spirits and provide you with powerful prayers and spiritual tools for breaking free from their control. God’s healing, restoration, and prosperity are available to you when you break the connection of the serpent and the soul.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katie Souza
      </h2>
      
      <p class="authorDescription body article"><B>Katie Souza</B> writes, teaches, and travels extensively. She is the founder of the prison outreach Expected End Ministries, which serves over 3,000 prisons in five countries, and the author of <I>The Captivity Series: The Key to Your Expected End</I> and <I>Healing the Wounded Soul</I>. She produces a live television show, <I>Healing Your Soul: Real Keys to the Miraculous</I>, which airs on international networks such as Daystar Television Network and Family Entertainment Television (FETV). Katie lives in Florida with her husband, Robert, and their two small dogs.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Charisma Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e13b4bc